module.exports = __webpack_public_path__ + "static/freecon-logo-637c978bc0252caad3dfeca6a3cdddad.png";